import { yupResolver } from '@hookform/resolvers/yup';
import LogoImg from 'assets/images/logo_login.png';
import WaveBackground from 'assets/images/wave_background.png';
import { notify } from 'components/ToastNotification/ToastNotification';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import paths from 'shared/paths';
import { useResetPasswordInitLazyQuery } from 'src/graphql/generated';
import { ToastTypes } from 'types/CommonTypes';
import {
    FormWrapper,
    Logo,
    PageBox,
    PageWrapper,
    StyledButton,
    StyledInput,
    StyledLink,
    WaveWrapper,
} from '../SharedLogin.styled';
import { validationResetPassword } from '../validations';

interface ResetPasswordFormInputs {
    email: string;
}

export const ResetPassword = () => {
    const history = useHistory();

    const {
        control,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm<ResetPasswordFormInputs>({
        resolver: yupResolver(validationResetPassword),
    });

    const [resetPasswordInit, { loading }] = useResetPasswordInitLazyQuery();

    const onSubmit = async (data: ResetPasswordFormInputs) => {
        try {
            const response = await resetPasswordInit({
                variables: {
                    email: data.email,
                },
            });

            if (response.data?.resetPasswordInit) {
                history.push(paths.new_password);
                notify('Pomyślnie rozpoczęto reset hasła, sprawdź maila')[
                    ToastTypes.SUCCESS
                ]();
                reset();
            } else {
                console.error('Reset password error:', response);
                notify(
                    'Nie udało się zresetować hasła, spróbuj ponownie: ' +
                        response.error?.message,
                )[ToastTypes.ERROR]();
            }
        } catch (error) {
            console.error('Reset password error:', error);
            notify('Nie udało się zresetować hasła, spróbuj ponownie')[
                ToastTypes.ERROR
            ]();
        }
    };

    return (
        <PageWrapper>
            <StyledLink to={paths.login}>
                <Logo src={LogoImg} />
            </StyledLink>
            <WaveWrapper src={WaveBackground} />
            <PageBox>
                <FormWrapper onSubmit={handleSubmit(onSubmit)}>
                    <StyledInput
                        control={control}
                        errors={errors.email}
                        name={'email'}
                        placeholder={'Email'}
                        type={'text'}
                        marginBottom={30}
                        iconType={'Email'}
                    />
                    <StyledButton
                        buttonType={'black'}
                        onPress={() => undefined}
                        disabled={isSubmitting || loading}
                    >
                        {isSubmitting || loading
                            ? 'resetowanie hasła...'
                            : 'zresetuj hasło'}
                    </StyledButton>
                </FormWrapper>
            </PageBox>
        </PageWrapper>
    );
};
